export default class BadRequestError extends Error {}
